import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import BackToTop from '@/components/feature/BackToTop';
import PageMeta from '@/components/base/PageMeta';
import HeroSection from './components/HeroSection';
import FeaturedComics from './components/FeaturedComics';
import HotRanking from './components/HotRanking';
import LatestUpdates from './components/LatestUpdates';
import CategoryGrid from './components/CategoryGrid';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <PageMeta
        title="抖漫网页版 - 在线漫画免费阅读平台 | 无需下载海量漫画在线畅读"
        description="抖漫网页版是无需下载APP即可在线畅读海量漫画的平台，支持PC端和手机浏览器直接访问。涵盖热血、恋爱、悬疑、搞笑等多种类型漫画，随时随地免费阅读，体验流畅、更新及时，是漫画爱好者的首选网页版入口。"
        keywords="抖漫网页版,抖漫网页版在线阅读,抖漫网页版免费漫画,抖漫网页版PC端,抖漫网页版入口,抖漫网页版怎么用,抖漫在线网页版访问"
        canonicalUrl="https://douman.readdy.ai"
        jsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '抖漫网页版 - 在线漫画免费阅读平台',
            description: '抖漫网页版是无需下载APP即可在线畅读海量漫画的平台，涵盖热血、恋爱、悬疑、搞笑等多种类型漫画。',
            url: 'https://douman.readdy.ai',
            isPartOf: {
              '@type': 'WebSite',
              name: '抖漫网页版',
              url: 'https://douman.readdy.ai',
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                { '@type': 'ListItem', position: 1, name: '首页', item: 'https://douman.readdy.ai' },
              ],
            },
          },
          {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '抖漫网页版需要下载APP吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '完全不需要！抖漫网页版是纯网页端漫画阅读平台，直接使用浏览器访问即可，无需下载任何APP或插件。支持PC端和手机浏览器，随时随地打开就能看漫画。',
                },
              },
              {
                '@type': 'Question',
                name: '抖漫网页版是免费的吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '是的，抖漫网页版目前所有漫画都是完全免费的。我们致力于为广大漫画爱好者提供优质的免费阅读体验，无需付费即可畅享海量正版漫画资源。',
                },
              },
              {
                '@type': 'Question',
                name: '抖漫网页版支持哪些设备访问？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '抖漫网页版支持所有主流设备：PC电脑端（Windows/Mac）、平板（iPad/Android平板）、手机浏览器（iOS Safari/Android Chrome等），您可以在任何有网络的设备上畅快阅读。',
                },
              },
              {
                '@type': 'Question',
                name: '抖漫网页版的漫画更新速度快吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '我们的漫画更新速度非常快，热门连载漫画基本与官方同步更新。团队有专人负责追踪各大漫画平台的更新动态，确保读者第一时间看到最新章节。',
                },
              },
              {
                '@type': 'Question',
                name: '抖漫网页版怎么用？有使用教程吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '使用非常简单！打开抖漫网页版后，您可以直接在首页浏览推荐漫画，或通过分类页面按类型筛选喜欢的漫画。点击任意漫画封面即可进入详情页开始阅读，支持键盘左右键翻页，阅读体验流畅自然。',
                },
              },
              {
                '@type': 'Question',
                name: '抖漫网页版的漫画资源丰富吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '我们的漫画资源非常丰富，涵盖热血、恋爱、悬疑、搞笑、奇幻、科幻、古风、都市等多种类型。目前收录了数千部优质漫画，并且每天都在不断扩充更新中。',
                },
              },
            ],
          },
        ]}
      />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedComics />
        <CategoryGrid />
        <HotRanking />
        <LatestUpdates />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}